<template>
  <Transition name="fade">
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div class="mx-2 w-full max-w-2xl max-h-full bg-white shadow-lg rounded-lg p-8 overflow-auto">
        <div
          v-if="this.modalAction === 'add'"
          class="w-full text-left px-3 pb-3 text-teal-700 text-2xl font-bold"
        >Nuevo lugar de interés</div>
        <div
          v-if="this.modalAction === 'edit'"
          class="w-full text-left px-3 pb-3 text-teal-700 text-2xl font-bold"
        >Actualización de lugar de interés</div>
        <div class="w-full text-right sticky top-0 right-0">
          <button aria-label="close" class="text-xl text-gray-500" @click.prevent="close">×</button>
        </div>
        <div class="flex flex-col items-center">
          <form class="w-full max-w-lg" @submit.prevent>
            <div class="flex flex-wrap -mx-3 mb-6">
              <div class="w-full px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="name"
                >Nombre</label>
                <input
                  class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                  id="name"
                  type="text"
                  v-model="place.nombre"
                />
              </div>
            </div>
            <div class="flex flex-wrap -mx-3 mb-6">
              <div class="w-full px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="description"
                >Descripción</label>
                <vue-editor
                  v-model="place.descripcion"
                  class="text-gray-700 border rounded mb-3 leading-tight"
                ></vue-editor>
                <!-- <textarea
                  class="appearance-none block w-full h-32 bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white resize-none"
                  id="description"
                  type="text"
                  v-model="place.descripcion"
                />-->
              </div>
            </div>
            <div class="flex flex-wrap -mx-3 mb-6">
              <div class="w-full px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="charge"
                >Costo</label>
                <input
                  class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                  id="charge"
                  type="text"
                  v-model="place.costo"
                />
              </div>
            </div>
            <div class="flex flex-wrap -mx-3 mb-6">
              <div class="w-full px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="activity"
                >Categoría</label>
                <div class="relative mb-3">
                  <select
                    class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    name="category"
                    id="category"
                    v-model="place.categoria_id"
                  >
                    <option disabled selected>Seleccione uno</option>
                    <template v-for="category in categories">
                      <option :key="category.id" :value="category.id">{{category.nombre_categoria}}</option>
                    </template>
                  </select>
                  <div
                    class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                  >
                    <svg
                      class="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path
                        d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex flex-wrap -mx-3 mb-6">
              <div class="w-full px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="activity"
                >Horario</label>
                <div
                  class="flex flex-col w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 rounded leading-tight"
                >
                  <div class="flex w-full pb-2 border-b border-gray-800 text-sm">
                    <div class="w-2/12">Día</div>
                    <div class="w-2/12">Habilitar</div>
                    <div class="w-4/12">Apertura</div>
                    <div class="w-4/12">Cierre</div>
                  </div>
                  <div
                    v-for="day in weekDay"
                    :key="day.day"
                    class="flex items-center w-full text-sm py-2"
                  >
                    <div class="w-2/12">{{day.dia}}</div>
                    <div class="w-2/12">
                      <input type="checkbox" v-model="place.working.enable[day.day]" value="true" />
                    </div>
                    <div class="flex w-4/12 justify-center">
                      <input
                        type="time"
                        v-model="place.working[day.day][0]"
                        name="hora"
                        value="00:00"
                        class="appearance-none block w-5/6 bg-gray-200 text-gray-700 border-2 border-gray-500 rounded py-2 px-2 leading-tight focus:outline-none focus:bg-white"
                      />
                    </div>
                    <div class="flex w-4/12 justify-center">
                      <input
                        type="time"
                        v-model="place.working[day.day][1]"
                        name="hora"
                        value="00:00"
                        class="appearance-none block w-5/6 bg-gray-200 text-gray-700 border-2 border-gray-500 rounded py-2 px-2 leading-tight focus:outline-none focus:bg-white"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="flex flex-wrap -mx-3 mb-3">
              <div class="w-1/2 px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="latitude"
                >Latitud</label>
                <input
                  class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                  id="latitude"
                  type="text"
                  v-model="place.lat"
                  disabled
                />
              </div>
              <div class="w-1/2 px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="longitude"
                >Longitud</label>
                <input
                  class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                  id="longitude"
                  type="text"
                  v-model="place.lng"
                  disabled
                />
              </div>
            </div>
            <div class="flex flex-wrap -mx-3 mb-6">
              <div class="h-64 w-full px-3 mb-6 md:mb-0">
                <l-map
                  ref="map"
                  class="h-full w-full z-0"
                  :zoom="zoom"
                  :minZoom="11"
                  :center="center"
                  :maxBounds="maxBounds"
                  :options="{zoomControl: false}"
                  @click="addMarker"
                  @ready="onMapReady"
                >
                  <l-geo-json :geojson="polygon" :options-style="geoStyle" />
                  <l-marker :lat-lng="coordinates" :visible="showMarker"></l-marker>
                </l-map>
              </div>
            </div>
            <div class="flex w-full justify-end">
              <button
                class="bg-secondary-color hover:bg-secondary-color-dark px-4 py-2 text-center rounded-lg text-white tracking-wide"
                @click="savePlace()"
              >Guardar</button>
              <button
                class="ml-2 bg-red-500 hover:bg-danger-color px-4 py-2 text-center rounded-lg text-white tracking-wide"
                @click="close()"
              >Cerrar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import { VueEditor } from "vue2-editor";
import polygon from "../assets/polygonChapp.json";

import L from "leaflet";
import { LMap, LMarker, LGeoJson } from "vue2-leaflet";
import * as esri from "esri-leaflet";

import { Icon } from "leaflet";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

export default {
  name: "place-modal",

  data() {
    return {
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
          "Access-Control-Allow-Headers": "*"
        }
      },
      configBinnacle: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
        }
      },
      coordinates: [0, 0],
      showMarker: false,
      categories: [],
      weekDay: [
        {
          dia: "Lunes",
          day: "monday"
        },
        {
          dia: "Martes",
          day: "tuesday"
        },
        {
          dia: "Miércoles",
          day: "wednesday"
        },
        {
          dia: "Jueves",
          day: "thursday"
        },
        {
          dia: "Viernes",
          day: "friday"
        },
        {
          dia: "Sábado",
          day: "saturday"
        },
        {
          dia: "Domingo",
          day: "sunday"
        }
      ],
      maxBounds: [
        [19.395295944890695, -99.22922388422747],
        [19.43212847837641, -99.17403475153704]
      ],
      polygon: polygon,
      zoom: 13,
      center: [19.412257, -99.200871],
      showMarker: false,
      geoStyle: {
        color: "#cb2833",
        fill: false
      }
    };
  },
  components: {
    LMap,
    LMarker,
    LGeoJson,
    VueEditor
  },
  props: {
    showing: {
      required: true,
      type: Boolean
    },
    place: {
      required: true
    },
    aux_place: {
      required: true
    },    
    modalAction: {
      required: true
    }
  },
  watch: {
    showing(value) {
      if (value) {
        if (this.modalAction === "edit") {
          this.showMarker = true;
          this.coordinates = [this.place.lat, this.place.lng];
        }
        return document.querySelector("body").classList.add("overflow-hidden");
      }

      document.querySelector("body").classList.remove("overflow-hidden");
    }
  },
  created() {
    let that = this;
/*     this.$socket.$subscribe("updateCategoryPlaceToMonitor", () => {
      that.fetchCategories();
    }); */
  },
  mounted() {
    this.fetchCategories();
  },
  methods: {
    onMapReady: function() {
      this.$nextTick(() => {
        const map = this.$refs.map.mapObject;
        esri.basemapLayer("Topographic").addTo(map);
      });
    },
    close() {
      this.showMarker = false;
      this.$emit("close", "dismiss");
    },
    savePlace() {
      let dayArray = [
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
        "sunday"
      ];
      dayArray.forEach(element => {
        if (!this.place.working.enable[element]) {
          this.place.working[element] = ["", ""];
        }
      });

      if (this.modalAction === "add") {
        this.axios
          .post("apidev/api/places", this.place, this.config)
          .then(response => {
            return this.axios.post("apidev/api/binnacles/monitor/save/",{
                "module": "Lugares de interés", 
                "action": "Creación de un lugar de interés", 
                "observation": this.place.nombre,
                "email": localStorage.getItem("email")
              },
              this.configBinnacle
            )
          })
          .then(response => {
            this.showMarker = false;
            this.$emit("close");
          });
      } else {
        if (this.modalAction === "edit") {
          //// removed console log
          this.axios
            .put(
              "apidev/api/places/" + this.place.id,
              this.place,
              this.config
            )
            .then(response => {
              let observation = ""
              if(this.place.nombre != this.aux_place.nombre){
                observation = `${this.aux_place.nombre} / ${this.place.nombre}`
              } else {
                observation = `${this.place.nombre}`
              }
              //// removed console log
              //this.current_place = this.place;

              return this.axios.post("apidev/api/binnacles/monitor/save/",{
                  "module": "Lugares de interés", 
                  "action": "Edición de un lugar de interés", 
                  "observation": observation,
                  "email": localStorage.getItem("email")
                },
                this.configBinnacle
              )
            })
            .then(response => {
              this.showMarker = false;
              this.$emit("close");
              this.$emit("updateData");
            });
        }
      }
    },
    addMarker(event) {
      let selectedCoordinates = event.latlng;
      this.place.lat = selectedCoordinates.lat;
      this.place.lng = selectedCoordinates.lng;
      this.coordinates = [this.place.lat, this.place.lng];
      this.showMarker = true;
    },
    fetchCategories() {
      this.axios
        .get("apidev/api/places/category", this.config)
        .then(response => {
          this.categories = response.data;
        });
    }
  }
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
